import { render, staticRenderFns } from "./salary.vue?vue&type=template&id=68a41b74&"
import script from "./salary.ts?vue&type=script&lang=ts&"
export * from "./salary.ts?vue&type=script&lang=ts&"
import style0 from "./salary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports